<script setup lang="ts">
import { DialogTitle, type DialogTitleProps } from "radix-vue"
import { cn } from "@/lib/utils"

const props = defineProps<DialogTitleProps & { class?: string }>()
</script>

<template>
  <DialogTitle
    v-bind="props"
    :class="
      cn(
        'text-foreground text-lg leading-none font-medium tracking-tighter',
        props.class
      )
    "
  >
    <slot />
  </DialogTitle>
</template>
